// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.pnpm/registry.npmjs.org/css-loader/3.6.0_webpack@4.43.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "ul.svelte-1mezgji:before{content:\"dependencies\";margin-right:0.5em}ul.svelte-1mezgji{list-style:none;padding:0px;margin:0px;display:flex}", ""]);
// Exports
module.exports = exports;
